import { convertDateUserLocalToUTCToEST, getFormattedTimeString, truncateTimeZoneDate } from './dates';
import { formBooleanToFlag, valueToNumber } from './format';

export const overChargeClaimsDetailsSectionLocalToAPI = (data) => {
  return {
    ...data,
    dateSubmitted: data?.dateSubmitted
      ? getFormattedTimeString(convertDateUserLocalToUTCToEST(data?.dateSubmitted))
      : null,
    ammendmentDate: data?.ammendmentDate
      ? getFormattedTimeString(convertDateUserLocalToUTCToEST(data?.ammendmentDate))
      : null,
    closedDate: data?.closedDate ? getFormattedTimeString(convertDateUserLocalToUTCToEST(data?.closedDate)) : null,
    checkDateToCustomer: data?.checkDateToCustomer
      ? getFormattedTimeString(convertDateUserLocalToUTCToEST(data?.checkDateToCustomer))
      : null,
    fbAttach: formBooleanToFlag(data?.fbAttach),
    bolAttach: formBooleanToFlag(data?.bolAttach),
    invAttach: formBooleanToFlag(data?.invAttach),
    otherAttach: formBooleanToFlag(data?.otherAttach),
  };
};

export const overChargeClaimsNotesSectionLocalToAPI = (data) => {
  return {
    ...data,
    claimComment: data.claimComment
      ? data.claimComment.map((row) => ({
          fbOcKey: data.fbOcKey,
          commentType: row.commentType,
          commentText: row.commentText,
          sequenceNo: row.sequenceNo,
          oldCommentType: row.oldCommentType,
          dirtyFlag: row.dirtyFlag,
        }))
      : [],
  };
};

export const overChargeClaimsItemsSectionLocalToAPI = (data) => {
  return {
    ...data,
    claimItem: data.claimItem
      ? data.claimItem.map((row) => ({
          fbOcKey: data.fbOcKey,
          dirtyFlag: row.dirtyFlag || 'N',
          itemID: row.itemID,
          proNo: row.proNo,
          invoiceNumber: row.invoiceNumber,
          packageNumber: row.packageNumber,
          shipDate: truncateTimeZoneDate(row.shipDate),
          weight: valueToNumber(row.weight),
          billedAmount: valueToNumber(row.billedAmount),
          paidAmount: valueToNumber(row.paidAmount),
          correctCharges: valueToNumber(row.correctCharges),
          overchargeAmount: valueToNumber(row.overchargeAmount),
          recoveryAmount: valueToNumber(row.recoveryAmount),
        }))
      : [],
  };
};

export const overChargeClaimsSettlementsSectionLocalToAPI = (data) => {
  return {
    ...data,
    claimSettlement: data.claimSettlement
      ? data.claimSettlement.map((row) => ({
          fbOcKey: data.fbOcKey,
          settlementSeq: row.settlementSeq,
          accountingCode: row.accountingCode,
          amount: valueToNumber(row.amount),
          dirtyFlag: row.dirtyFlag,
        }))
      : [],
  };
};

export const checkDuplicateOverchargeItem = (items, duplicateValue) => {
  const returnData = { isHavingDuplicateItem: false, duplicateMessage: '' };
  if (duplicateValue) {
    const duplicatedItem = items.find(({ proNo, invoiceNumber, packageNumber }) =>
      [String(proNo), String(invoiceNumber), String(packageNumber)].includes(duplicateValue),
    );
    if (duplicatedItem) {
      let duplicatedField = false;

      if (duplicateValue === String(duplicatedItem.proNo)) {
        duplicatedField = 'Freight Bill';
      } else if (duplicateValue === String(duplicatedItem.invoiceNumber)) {
        duplicatedField = 'Invoice Number';
      } else if (duplicateValue === String(duplicatedItem.packageNumber)) {
        duplicatedField = 'Package Number';
      }
      if (duplicatedField) {
        returnData.isHavingDuplicateItem = true;
        returnData.duplicateMessage = `An Overcharge Claim has already been filed for this ${duplicatedField}: ${duplicateValue}`;
      }
    }
  }
  return returnData;
};
